import apiClient, { IresponseData, IresponseDataPaginated } from "@/lib/api";

export interface ProfileUser {
  id: string;
  email: string;
  firstName: string;
  lastName: string;
  rol: string;
  account: {
    id: string;
    accountCode: string;
    nameAccount: string;
    email: string;
    status: string;
    schemaName: string;
    createdAt: string;
    updatedAt: string;
  };
}

export interface PlanFeature {
  id: string;
  code: string;
  name: string;
  description: string;
  isPremium: boolean;
}

export interface Plan {
  id: string;
  name: string;
  description: string;
  maxClients: number;
  maxStreamingAccounts: number;
  maxCollaborators: number;
  priceMonthly: string;
  priceYearly: string;
  features?: PlanFeature[];
}

export interface Subscription {
  id: string;
  status: string;
  billingCycle: string;
  startDate: string;
  endDate: string | null;
  trialEndsAt: string | null;
}

export interface SubscriptionData {
  subscription: Subscription;
  plan: Plan;
  features: PlanFeature[];
}

export interface BillingRecord {
  id: string;
  accountId: string;
  amount: string;
  currency: string;
  paymentMethod: string;
  status: string;
  invoiceNumber: string;
  billingPeriodStart: string;
  billingPeriodEnd: string;
  paidAt: string;
  notes: string | null;
  createdAt: string;
  updatedAt: string;
}

export const profileService = {
  async getProfile(): Promise<IresponseData<ProfileUser>> {
    const response = await apiClient.post<IresponseData<ProfileUser>>("/auth/me");
    return response.data;
  },

  async getSubscription(): Promise<IresponseData<SubscriptionData>> {
    const response = await apiClient.get<IresponseData<SubscriptionData>>("/accounts/subscription");
    return response.data;
  },

  async getPlans(): Promise<IresponseData<Plan[]>> {
    const response = await apiClient.get<IresponseData<Plan[]>>("/accounts/plans");
    return response.data;
  },

  async getBillingHistory(): Promise<IresponseDataPaginated<BillingRecord[]>> {
    const response = await apiClient.get<IresponseDataPaginated<BillingRecord[]>>("/accounts/billing-history");
    return response.data;
  },
};
